module.exports = __webpack_public_path__ + "img/KSC05790.49418a08.jpg";